import React from "react";

function Logo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="39"
      version="1.1"
      viewBox="0 0 11.113 10.319"
      xmlSpace="preserve"
    >
      <g transform="translate(-105.483 -82.223)">
        <g
          fill="#fff"
          fillOpacity="1"
          stroke="none"
          strokeDasharray="none"
          strokeOpacity="1"
          strokeWidth="7.9"
          transform="matrix(.32842 0 0 .32812 4411.667 6444.964)"
        >
          <path
            d="M-13110.336-19360.311c-.07-.08-.233-.705-.369-1.388a197.276 197.276 0 00-.872-4.207l-.388-1.794.924-1.494c.508-.821 1.023-1.667 1.144-1.88.777-1.37 2.125-3.488 2.219-3.488.107 0 .267.32.99 1.973.659 1.506.774 1.765.972 2.179.112.233.204.478.204.544 0 .07.164.483.365.928l.731 1.615c.201.445.365.838.365.874 0 .04.195.491.434 1.011l.433.947-.773 1.651c-.426.909-.866 1.863-.978 2.121l-.205.469-2.537.04c-1.568.03-2.584-.01-2.659-.104z"
            opacity="1"
          ></path>
          <path
            d="M-13100.981-19360.375c0-.08.471-1.095 1.047-2.262l1.047-2.122-.487-1.065c-.267-.585-.763-1.656-1.102-2.38-.338-.723-.763-1.644-.943-2.046-.18-.402-.51-1.125-.734-1.608l-.912-1.973c-.278-.603-.739-1.589-1.023-2.192a108.41 108.41 0 01-.84-1.827 68.468 68.468 0 00-.745-1.603l-.421-.871 3.385-3.396c3.179-3.19 3.395-3.377 3.547-3.075.09.176.352.782.584 1.344.467 1.132.811 1.934 1.251 2.922.16.361.292.688.292.727 0 .04.172.45.383.915.45.992.415.911 1.957 4.571.66 1.568 1.323 3.122 1.472 3.454.149.332.578 1.351.951 2.266.374.914.81 1.957.969 2.319a1588.626 1588.626 0 001.206 2.76c.364.834.663 1.604.663 1.712 0 .172-1.115 2.706-1.441 3.275-.108.187-.862.225-5.116.258-3.125.02-4.99-.01-4.99-.103z"
            opacity="1"
          ></path>
          <path
            d="M-13090.89-19377.422c-.245-.539-.445-.999-.445-1.023 0-.02-.23-.54-.511-1.149-.282-.609-.512-1.133-.512-1.164 0-.03-.296-.685-.658-1.454-.361-.769-.657-1.429-.657-1.468 0-.04-.19-.485-.423-.993a196.657 196.657 0 01-1.506-3.335 115.377 115.377 0 00-1.05-2.38c-.211-.464-.383-.941-.383-1.059 0-.186.6-.213 4.275-.198 2.352.01 4.961.06 5.798.11l1.522.09.317.878c.175.482.356.975.402 1.096.328.858 1.439 4.272 1.4 4.304-.07.06-5.35.374-6.296.373-.587 0-.841.06-.841.187 0 .104.461 1.358 1.024 2.789.562 1.43 1.023 2.651 1.023 2.713 0 .16-1.745 2.56-1.903 2.616-.07.03-.332-.395-.576-.934z"
            opacity="1"
          ></path>
          <path
            d="M-13086.423-19360.859c.127-.342.3-.786.383-.987.577-1.384.805-2.116.729-2.338-.04-.121-.222-.548-.402-.95a374.62 374.62 0 01-1.894-4.385 72.62 72.62 0 00-.547-1.243c-.627-1.389-.628-1.42-.1-2.17.265-.374.519-.712.564-.753.04-.04.967-1.257 2.051-2.704 1.463-1.954 1.984-2.556 2.025-2.338.03.16.102.358.16.438.06.08.22.475.361.877.273.781.369 1.024.718 1.827.122.282.722 1.794 1.333 3.362.61 1.568 1.183 3.015 1.273 3.216.09.2.213.497.273.657.559 1.492 1.159 2.987 1.337 3.335.101.196-.04.734-.54 2.046-.372.98-.737 1.895-.811 2.035a1.31 1.31 0 00-.135.475c0 .191-.473.221-3.506.221h-3.507z"
            opacity="1"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default Logo;
